module.exports = __webpack_public_path__ + "static/img/pic_zsmoban@2x.7049cbb0.png";